export const fetchCoursesApiResponse = {
    "contentGroupIdMap": [
        {
            "key": 43,
            "value": {
                "code": "rc",
                "id": 43,
                "title": "Books and Passages"
            }
        }
    ],
    "gradeCodeMap": [
        {
            "key": "pk",
            "value": {
                "code": "pk",
                "id": 7,
                "ordering": 4,
                "title": "Pre-Kindergarten"
            }
        },
        {
            "key": "k",
            "value": {
                "code": "k",
                "id": 1,
                "ordering": 5,
                "title": "Kindergarten"
            }
        }

    ],
    "gradeIdMap": [
        {
            "key": 7,
            "value": {
                "code": "pk",
                "id": 7,
                "ordering": 4,
                "title": "Pre-Kindergarten"
            }
        },
        {
            "key": 1,
            "value": {
                "code": "k",
                "id": 1,
                "ordering": 5,
                "title": "Kindergarten"
            }
        },
        {
            "key": 2,
            "value": {
                "code": "1",
                "id": 2,
                "ordering": 6,
                "title": "Grade 1"
            }
        },
        {
            "key": 3,
            "value": {
                "code": "2",
                "id": 3,
                "ordering": 7,
                "title": "Grade 2"
            }
        }
    ],
    "subjectCodeMap": [
        {
            "key": "math",
            "value": {
                "code": "math",
                "created_at": "2022-03-23T14:13:02.182Z",
                "id": 1,
                "meta_description": null,
                "title": "Math",
                "updated_at": "2022-03-23T14:13:02.182Z"
            }
        },
        {
            "key": "ela",
            "value": {
                "code": "ela",
                "created_at": "2022-03-23T14:15:06.600Z",
                "id": 2,
                "meta_description": null,
                "title": "Reading",
                "updated_at": "2022-03-23T14:15:06.600Z"
            }
        }
    ],
    "subjectGradeMap": [
        {
            "key": 1,
            "value": [
                {
                    "code": "ccss:prek:math",
                    "content_groups": [36,37,38,39,1],
                    "grade_id": 7,
                    "id": 43,
                    "subject_id": 1
                },
                {
                    "code": "ccss:k:math",
                    "content_groups": [7,1,16,12,11],
                    "grade_id": 1,
                    "id": 1,
                    "subject_id": 1
                }
            ]
        },
        {
            "key": 2,
            "value": [
                {
                    "code": "ccss:npk:ela",
                    "content_groups": [32,34,33,29,35],
                    "grade_id": 7,
                    "id": 23,
                    "subject_id": 2
                },
                {
                    "code": "ccss:k:ela",
                    "content_groups": [45,27,28,29,30,31],
                    "grade_id": 1,
                    "id": 20,
                    "subject_id": 2
                }
            ]
        }
    ],
    "subjectIdMap": [
        {
            "key": 1,
            "value": {
                "code": "math",
                "created_at": "2022-03-23T14:13:02.182Z",
                "id": 1,
                "meta_description": null,
                "title": "Math",
                "updated_at": "2022-03-23T14:13:02.182Z"
            }
        },
        {
            "key": 2,
            "value": {
                "code": "ela",
                "created_at": "2022-03-23T14:15:06.600Z",
                "id": 2,
                "meta_description": null,
                "title": "Reading",
                "updated_at": "2022-03-23T14:15:06.600Z"
            }
        }
    ]
}

export const abTestDetailsAfterLoginAPIResponse = {
    "is_desktop": true,
    "show_app_download_cta": true,
    "is_modular": true,
    "skip_poq": true,
    "skip_poq_subject": true,
    "skip_fork_screen": true,
    "user_intention_question": false,
    "ad_links": {
        "ios": "https://apps.apple.com/app/apple-store/id672658828?pt=481348&ct=O_HomePage_Button&mt=8",
        "android": "https://play.google.com/store/apps/details?id=com.splash.kids.education.learning.games.free.multiplication.reading.math.grade.app.splashmath&referrer=utm_source=O&utm_medium=HomePage&utm_term=Button"
    }
}